import { redirect } from 'react-router-dom';

import { getStoredTokenData } from '../store/auth-context';

export function CheckAuthLoader() {
	const token = getStoredTokenData().token;
	if (!token) {
		return redirect('/login');
	}
	return null;
}
